import { Component, OnInit } from '@angular/core';
import { UsersService } from '../_services/users.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { DataTablesModule } from 'angular-datatables';
import { Ambassador, Report, Export } from '../models/ambassador.model';
import { CommonModule } from '@angular/common';
import { PAGE_LIMIT } from '../_constants/common.constants';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-ambassadors',
  imports: [
    CommonModule,
    DataTablesModule,
    RouterModule
  ],
  templateUrl: './ambassadors.component.html',
  styleUrl: './ambassadors.component.css',
  standalone: true
})
export class AmbassadorsComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  ambassadors: Ambassador[];

  qrCodeBaseUrl = `${environment.qrCodeBaseUrl}`;

  constructor(
    private userService: UsersService,
    private toastr: ToastrService) { }
    
  search_key: string;
  title = 'Excel';
  dtTrigger: Subject<any> = new Subject();
  reports: Report[];
  reportsExport: Export[];

  ngOnInit(): void {
    this.loadAmbassadorList();
  }

  loadAmbassadorList() {
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: PAGE_LIMIT,
      serverSide: true,
      processing: true,
      order: [[5, 'desc']],
      language: {
        searchPlaceholder: 'Name|Phone|Email'
      },
      ajax: (dataTablesParameters: any, callback) => {
        this.search_key = dataTablesParameters.search.value;
        this.userService.ambassadorListing(dataTablesParameters).
          subscribe({
            next: (response: any) => {
              that.ambassadors = response.data.user_listing;
              callback({
                recordsTotal: response.data.total_count,
                recordsFiltered: response.data.total_count,
                data: []
              });
            },
            error: (err: any) => {
              this.toastr.error(err.error);
              callback({
                processing: false,
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
          }
          );
      },
      columns: [{ data: 'name' }, { data: 'username' }, { data: 'phone_number' }, { data: 'email' }, { data: 'ambassadorEnabledOn' }, { data: 'referralCount' }, { data: 'isAmbassador'}]
    };
  }
}
